import { Element } from "react-scroll";
import skillsPic from "../assets/images/side-view.png";
import skills from "../data/skills";
export default function SkillsSection() {
  return (
    <Element className="section section--skills" name="skills">
      <div className="section__head">
        <h1> skills</h1>
      </div>
      <div className="grid-container grid-container--split grid-container--skills">
        <div className="section--skills__content">
          <div className="section--skills__progress-title">
            <h2>I believe in</h2>
            <p>
              {" "}
              building intelligent, user-centered products by combining thoughtful design, strong engineering principles, and AI-driven innovation. I focus on creating intuitive interfaces and seamless experiences that solve real problems, adapt to user needs, and deliver meaningful product value.
            </p>
          </div>
          <div className="section--skills__progress">
            {skills.map((skill) => {
              return (
                <div
                  className="section--skills__progress-item"
                  key={skill.name}
                >
                  <div className="pulse-circle"></div>
                  <h3>{skill.name}</h3>
                </div>
              );
            })}
          </div>
        </div>
        <div className="section--skills__media">
          <img src={skillsPic} alt="skills" loading="lazy" />
        </div>
      </div>
    </Element>
  );
}
